import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from '@material-ui/core';
import { getIn } from 'formik';
import React from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

interface IProps extends FieldProps {
  label: string;
  fullWidth?: boolean;
  checked?: boolean;
}

export const CheckboxFormField = ({ field, form, label, checked, fullWidth = true, ...props }: IProps) => {
  const errorText = getIn(form.errors, field.name);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
    form.setFieldValue(field.name, checked);
  }

  return (
    <FormControl fullWidth={fullWidth} error={!!errorText}>
      <Hint inputName={field.name}>
        <FormGroup>
          <FormControlLabel label={label} control={<Checkbox checked={checked || !!field.value || false} onChange={handleChange} {...props} />} />
        </FormGroup>
      </Hint>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};
